export const ChapterLabel = ({ text }) => (
  <div className="flex items-center gap-4 mb-8" data-testid={`chapter-label-${text.split(" ")[1]?.toLowerCase() || "section"}`}>
    <span className="h-px w-12 bg-white/25" />
    <span className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-400">
      {text}
    </span>
  </div>
);
